<template>
  <div class="row">
      <SideBar/>
      <nav class="col s12 m12 l10 right white">
        <div class="nav-wrapper">
          <a href="#" class="brand-logo grey-text text-darken-2">Agencias</a>
        </div>
      </nav>
      <nav class="col s12 m12 l10 right white">
        <div class="nav-wrapper">
          <form>
            <div class="input-field">
              <input id="search" type="search" v-model="search" required>
              <label class="label-icon" for="search"><i class="material-icons grey-text">search</i></label>
              <i class="material-icons">close</i>
            </div>
          </form>
        </div>
      </nav>
      <div class="col s12 m12 l10 right">
        <div class="col s12 center" v-if="agencies.list.length<1">
          <div class="preloader-wrapper big active" style="margin-top:5%">
            <div class="spinner-layer spinner-white-only">
              <div class="circle-clipper left">
                <div class="circle"></div>
              </div><div class="gap-patch">
                <div class="circle"></div>
              </div><div class="circle-clipper right">
                <div class="circle"></div>
              </div>
            </div>
          </div>
          <h5 class="white-text light">Cargando...</h5>
        </div>
        <div class="">
          <table>
             <thead>
               <tr>
                   <th>Nombre</th>
                   <th>Cuidad</th>
                   <th>Estado</th>
                   <th>Acciones</th>
               </tr>
             </thead>

             <tbody v-if="agencies.list.length>1">
               <tr v-bind:key="index" v-for="(agency,index) in filterList">
                 <td class="black-text text-trasnform">{{limitText(agency.agency)}}</td>
                 <td>{{getCountry(agency.country)}}</td>
                 <td><span v-bind:class="'chip '+colorState(agency.state)">{{getState(agency.state)}}</span></td>
                 <td><a v-bind:href="'#/agency/'+agency.nit" class="btn-flat grey lighten-3">editar</a> </td>
               </tr>
             </tbody>
           </table>
        </div>
        <div class="collection no-border" v-if="agencies.list.length>1">
          <!--
          <div class="col s12 m6 l4">
            <div class="col s12 " v-bind:key="index" v-for="(agency,index) in onlineList">
                <a v-bind:href="'#/agency/'+agency.nit" class="collection-item avatar transparent no-border waves-effect">
                  <i class="circle blue-dark-gradient">{{agency.agency.substring(0, 1)}}</i>
                  <p class="black-text text-trasnform">{{limitText(agency.agency)}}</p>
                  <p class="grey-text">{{getCountry(agency.country)}}</p>
                  <p class="grey-text">
                    <span v-bind:class="'chip white-text '+colorState(agency.state)">{{getState(agency.state)}}</span>
                  </p>
                </a>
            </div>
          </div>-->
          <!--<div class="col s12 m6 l4">
            <div class="col s12 " v-bind:key="index" v-for="(agency,index) in initialList">
                <a v-bind:href="'#/agency/'+agency.nit" class="collection-item avatar transparent no-border waves-effect">
                  <i class="circle blue-dark-gradient white-text">{{agency.agency.substring(0, 1)}}</i>
                  <p class="black-text text-trasnform">{{limitText(agency.agency)}}</p>
                  <p class="grey-text">{{getCountry(agency.country)}}</p>
                  <p class="grey-text">
                      <span v-bind:class="'chip white-text '+colorState(agency.state)">{{getState(agency.state)}}</span>
                  </p>
                </a>
            </div>
          </div>-->
          <!--
          <div class="col s12 m6 l4">
            <div class="col s12" v-bind:key="index" v-for="(agency,index) in offlineList">
              <a v-bind:href="'#/agency/'+agency.nit" class="collection-item avatar transparent no-border waves-effect">
                <i class="circle blue-dark-gradient white-text">{{agency.agency.substring(0, 1)}}</i>
                <p class="black-text text-trasnform">{{limitText(agency.agency)}}</p>
                <p class="grey-text">{{getCountry(agency.country)}}</p>
                <p class="grey-text">
                  <span v-bind:class="'chip white-text '+colorState(agency.state)">{{getState(agency.state)}}</span>
                </p>
              </a>
            </div>
          </div>-->
        </div>
      </div>
  </div>
</template>

<script>
//Vue.component("agencies",
import * as firebase from "firebase/app"
import SideBar from '../components/SideBar'
export default{
  data: function() {
      return {
        "search": "",
        "agencies":[],
        "states":{},
        "cities":{
          "ref":firebase.database().ref('cities'),
          "list":[]
        }
      }
  },
  components:{
    SideBar
  },
  created: function () {
    this.$root.validateSesion()
    this.agencies = this.getAgenciesList()
  },
  beforeCreate: ()=>{
    //$('.tooltipped').tooltip({delay: 10});
  },
  methods:{
    limitText (text) {
      let body = this.stripTags(text);
      return body.length > 20 ? body.substring(0, 20) + '...' : body
    },
    stripTags (text) {
        return text.replace(/(<([^>]+)>)/ig, '')
    },
    colorState(state) {
      switch (state) {
        case 0:
          return "green accent-2 green-text"
        case 1:
          return "blue lighten-4 blue-text"
        case 2:
          return "red accent-1 red-text"
        case 3:
          return "orange lighten-3 orange-text"
        case 4:
          return "grey lighten-2 grey-text"
        default:

      }
    },
    getState(state) {
      switch (state) {
        case 0:
          return "Online"
        case 1:
          return "Inicial"
        case 2:
          return "Offline"
        case 3:
          return "En Proceso"
        case 4:
          return "No Continuo"
        default:

      }
    },
    getAgenciesList: function() {
      this.agencies = {
        ref: firebase.database().ref('agenciestest/'+this.$root.page),
        list: []
      }
      this.agencies.ref.once('value', (snapshot)=> {
        snapshot.forEach((childSnapshot)=> {
          this.agencies.list.push(childSnapshot.val())
        });
      });
      this.cities.ref.once('value', (snapshot)=> {
        snapshot.forEach((childSnapshot)=> {
          this.cities.list.push(childSnapshot.val())
        });
      });
      return this.agencies
    },
    clickAgency:function () {
      //console.log(agency);
    },
    getCountry:function(country) {
      var i = 0
      for (i = 0; i < this.cities.list.length; i++) {
          if (i == parseInt(country)) {
            return this.cities.list[i]
          }
      }
    }
  },
  computed: {
    filterList() {
      return this.agencies.list.filter((agency) => {
        //if (agency.agency != null&&agency.state==0) {
        return agency.agency.toLowerCase().includes(this.search.toLowerCase());
        //}
      });
    },
  }
}
</script>
